import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { Constants } from '../../core/config/Constants'
import { ExtraService } from '../../core/services/extra.service';
import { SessionService } from '../../core/services/session.service';
import { PollService } from '../../core/services/poll.service';
import { Poll } from '../../core/models/poll';
import { Poll as NewPoll } from '../../core/models/poll-new';
import { PollQuestionModel } from '../../core/models/poll-question';
import { PollOptionsModel } from '../../core/models/poll-options';
import { PollListService } from '../../core/services/poll-list.service';
import { UtilityService } from '../../core/services/utility.service';

@Component({
    selector: 'app-poll-question',
    templateUrl: './poll-question.component.html',
    styleUrls: ['./poll-question.component.css'],
    providers: [SessionService, ExtraService, PollService, PollListService]
})
export class PollQuestionComponent implements OnInit,OnChanges {

    pageTitle: string = 'Poll Question';
    pageAlias: string = 'poll-form';
    disableButton = true;
    questionClass: string;
    optionClass: string;
    prop: string = '';
    eventId: string = '';
    pollId: string = '';
    eventSessionId: string = '';
    session_name: string;
    sessionList = new Array<any>();

    typeList = new Array<{ text: string, value: string }>();
    typeName: string;
    pollKey: string;
    pollObject: any = new Poll();
    selectedPollObject : any = new Poll();

    errorMessage = new Array<string>();
    classArray = new Array<string>();
    isError: boolean = false;
    message: string = '';

    reason: boolean = false;
    mquestions: boolean = false;
    reasonMandatory: boolean = false;
    pollList: Array<Poll> = new Array();
    newPollList = new Array();
    allPolls = new Array();
    newPollData;
    pollIdList: Array<any> = new Array();
    optionIDList: Array<any> = new Array();
    selectedPolls: Array<any> = new Array();

    eventLists: boolean = true;

    poll = new PollQuestionModel();
    prevPoll:string

    constructor(private pollListService: PollListService, private extraService: ExtraService, private route: ActivatedRoute, private router: Router,
        private sessionService: SessionService, private pollService: PollService, private utilityService: UtilityService) {
    }

    ngOnInit() {
        this.typeList = [
            { text: 'MCQ SINGLE', value: 'MCQ_SINGLE' },
            { text: 'MCQ MULTIPLE', value: 'MCQ_MULTIPLE' },
            { text: 'RATING', value: 'RATING' },
            { text: 'TEXT', value: 'TEXT' },
            { text: 'NUMBER', value: 'NUMBER' }
        ];
        this.addItem();
        this.addItem();
        this.extraService.changeStateofSideBarButton(true);
        this.extraService.changeSideBar(true);
        this.route.queryParams.subscribe(params => {
            let id = params['eventId'];
            let pollID = params['pollId'];
            let pollQuestionId = params['pollQuestionId'];
            let SESSION_ID = params['sessionId'];
            if (SESSION_ID) {
                this.eventSessionId = SESSION_ID;
            } if (id) {
                this.eventId = id;
                let speakerId = null;
                this.setPollList(id);
                this.extraService.setCurrentEventId(id);
            }
            // if (pollID) {
            //     this.pollId = pollID;
            //     this.setPollDetails(this.eventId, this.pollId);
            // }
            if (pollQuestionId) {
                this.pollId = pollQuestionId;
                this.setPollDetails(this.eventId, this.pollId);
            }
        });
    }
    ngOnChanges(changes: SimpleChanges): void {
        console.log("changes",changes)
    }

    setPollList(eventId) {
        console.log("======== setPollList ======");
        this.message = null;
        this.allPolls = [];
        var x = this.pollService.getPollList(eventId)
        x.snapshotChanges().subscribe(list => {
            this.pollList = new Array();
            this.pollIdList = new Array();
            list.forEach(element => {
                var y = element.payload.toJSON() as Poll;
                y["$key"] = element.key;
                // console.log(y);
                this.allPolls.push(y);
            });
            //this.setSelectedPolls();
        });
    }

    addItem() {
        this.poll.options.push('');
        this.classArray.push('');
    }

    trackByIndex(index: number, value: number) { return index; }

    removeItem(index) {
        if (this.poll.options.length > 2) {
            this.poll.options = this.poll.options.filter((val, i) => i != index);
            this.classArray = this.classArray.filter((val, i) => i != index)
        }
    }

    receiveSession($event) {
        if ($event.prop == 'event') {
            this.prop = $event.prop;;
            this.poll.eventId = this.eventId;
            // this.poll.sessionId = null
        } if ($event.prop == 'session') {
            this.poll.eventId = this.eventId;
            this.prop = $event.prop;
            // this.poll.sessionId = $event.sessionId;
        }
    }

    setType(value) {
        this.poll.pollType = this.typeName = value;
    }

    setPoll(value) {
        // console.log(value);
        this.pollObject = value;
        this.pollKey = value.$key;
    }

    setPollDetails(eventId, pollId) {
        // console.log(eventId, pollId);
        this.pollService.getPollQuestion(eventId, pollId).subscribe(event => {
            if (event) {
                this.poll = event;
                 console.log(this.poll);
                if (event.pollType) { this.typeName = event.pollType }
                if(event.pollId != undefined)
                {
                    if(event.pollId.length>0){
                        this.prevPoll = event.pollId[0];
                        console.log("ptr",this.prevPoll)
                    this.setSelectedPolls();
                    }
                }
                else{
                    this.poll.pollId=new Array<string>();
                }
                // if (event.sessionId) { this.eventSessionId = event.sessionId; }
                if (this.poll.pollType === 'MCQ_SINGLE' || this.poll.pollType === 'MCQ_MULTIPLE') {
                    if (!this.poll.options || this.poll.options.length < 1) {
                        this.poll.options = new Array();
                        this.addItem();
                    } else {
                        let optText = [];
                        this.optionIDList = this.poll.options;
                        this.poll.options.map(item => {
                            this.pollService.getPollOptions(eventId, item).subscribe(opt => {
                                // console.log(opt);
                                optText.push(opt.option);
                            });
                        });
                        this.poll.options = optText;
                    }
                }
                
            }
        });
    }


    setSelectedPolls() {
        console.log('====setSelectedPolls===='); //this.newPollList
        let selectedPolls = [...this.allPolls];
        if (this.allPolls.length > 0) {
            if (this.poll.pollId && this.poll.pollId.length > 0) {
                this.poll.pollId.forEach(element => {
                    let ind = selectedPolls.findIndex(x => x.$key === element);
                    if (ind != -1) {
                        console.log(element);
                        selectedPolls.splice(ind, 1);
                    }
                })
            }
        }
        const results = this.allPolls.filter(function(o1){
            return !selectedPolls.some(function(o2){    //  for diffrent we use NOT (!) befor obj2 here
               return o1.$key == o2.$key;          // id is unnique both array object
             });
           });
        this.pollObject = results[0];
        console.log("answer",this.allPolls, selectedPolls,this.selectedPollObject);
        this.newPollList = selectedPolls;
    }
   
   

    removeFromPolls(removedPoll) {
        console.log("===== removeFromPolls =====");

        let newQuestionSet = [];
        let pollObject = { ...this.newPollList.find(item => item.$key === removedPoll.value) };
        // console.log(pollObject);
        delete pollObject.$key;
        if (pollObject.questions !== undefined && pollObject.questions.length > 0) {
            newQuestionSet = Object.values(pollObject.questions);
            let index = newQuestionSet.indexOf(removedPoll.value);
            newQuestionSet.splice(index, 1);
        }
        let selectedPollIndex = this.selectedPolls.findIndex(x => x.value === removedPoll.value);
        this.selectedPolls.splice(selectedPollIndex, 1);
        // console.log(this.eventId, removedPoll.value, { ...pollObject, questions: newQuestionSet });

        let removedPollIndex = this.poll.pollId.indexOf(removedPoll.value);
        this.poll.pollId.splice(removedPollIndex, 1);
        this.pollService.updatePollDetail(this.eventId, removedPoll.value, { ...pollObject, questions: newQuestionSet });
    }

    submit() {
        this.clearClasses();
        this.message = null;
        this.poll.eventId = this.eventId;
        if (this.validate()) {
            if (!this.pollId) {
                if (this.errorMessage.length == 0) {
                    let email = this.utilityService.getUserEmail();
                    this.poll.createdBy = email;
                    if (this.poll.pollType === 'MCQ_SINGLE' || this.poll.pollType === 'MCQ_MULTIPLE') {
                        for (var i = 0; i < this.poll.options.length; i++) {
                            if (this.poll.options[i] == "") {
                                this.poll.options[i] = null;
                            }
                        }
                    }
                    this.add();
                }
            } else {
                if (this.errorMessage.length == 0) {
                    if (this.poll.pollType === 'MCQ_SINGLE' || this.poll.pollType === 'MCQ_MULTIPLE') {
                        for (var i = 0; i < this.poll.options.length; i++) {
                            if (this.poll.options[i] == "") {
                                this.poll.options[i] = null;
                            }
                        }
                    }
                    this.update();
                }
            }
        } else {
            this.isError = true;
        }

    }

    validate() {
        let valid = true;
        this.isError = false;
        this.errorMessage = new Array<string>();
        // if (this.reason) {
        //     this.poll.isReasonAvailable = this.reason;
        // } if (this.reasonMandatory) {
        //     this.poll.isReasonMandatory = this.reasonMandatory;
        // } if (this.prop == 'session' && !this.poll.sessionId) {
        //     this.isError = true;
        //     this.errorMessage.push("Please select session from dropdown");
        //     valid = false;
        // }

        if (this.poll.pollType === 'MCQ_SINGLE' || this.poll.pollType === 'MCQ_MULTIPLE') {
            if (this.poll.options.length > 0) {
                for (var i = 0; i < this.poll.options.length; i++) {
                    if (this.poll.options[i].length == 0) {
                        if (i == 1 || i == 0) {
                            this.isError = true;
                            valid = false;
                            this.optionClass = "form-control fieldWithErrors";
                            this.errorMessage.push("Min 2 poll options needed");
                        } else {

                        }
                    }
                }
            }
        }

        if (this.poll.pollQuestion == null) {
            this.isError = true;
            this.errorMessage.push("Poll question can not be empty");
            this.questionClass = "form-control fieldWithErrors";
            valid = false;
        }
        return valid;
    }

    clearClasses() {
        this.questionClass = 'form-control';
        this.optionClass = 'form-control';
    }


    add() {
        this.disableButton = false;
        this.poll.position = this.pollList.length;
        let poll = this.poll;
        // addPollOptions

        if (this.poll.pollType === 'MCQ_SINGLE' || this.poll.pollType === 'MCQ_MULTIPLE') {
            let optionId = [];
            this.poll.options.map(item => {
                let opt = new PollOptionsModel();
                opt.option = item;
                optionId.push(this.pollService.addPollOptions(this.eventId, opt));
            });
            this.poll.options = optionId;
        }

        if (this.pollKey) {
            this.poll.pollId.push(this.pollKey);
        }

        let pollkey = this.pollService.addPollQuestion(this.eventId, poll);

        if (pollkey) {
            this.message = 'Added Successfully';
            setTimeout(function () {
                this.disableButton = true;
                this.message = null;

                if (this.pollKey) {
                    let newQuestionSet = [];
                    let pollObject = { ...this.pollObject };
                    delete pollObject.$key;
                    if (pollObject.questions !== undefined) {
                        newQuestionSet = Object.values(pollObject.questions);
                    }
                    newQuestionSet.push(pollkey);
                    let questionSet = newQuestionSet.filter((v, i, a) => a.indexOf(v) === i);
                    this.pollService.updatePollDetail(this.eventId, this.pollKey, { ...pollObject, questions: questionSet });
                }

                this.router.navigate([Constants.POLL_FORM, this.eventId]);

            }.bind(this), 1000);
        }
    }

    update() {
        this.disableButton = false;
        let poll = this.poll;
        let prevPolls = this.prevPoll
        let prevPollsDetails :any
debugger
        if (this.poll.pollType === 'MCQ_SINGLE' || this.poll.pollType === 'MCQ_MULTIPLE') {
            let optionId = [];
            this.poll.options.map((item, index) => {
                let opt = new PollOptionsModel();
                opt.option = item;
                this.pollService.updatePollOptions(this.eventId, this.optionIDList[index], opt);
                optionId.push(this.optionIDList[index]);
                // optionId.push(this.pollService.addPollOptions(this.eventId, opt));
            });
            this.poll.options = optionId;
        }
        if (this.pollKey) {
            // console.log(this.poll.pollId);
            let ids = [this.pollKey];
            let newids = ids.filter((v, i, a) => a.indexOf(v) === i);
            this.poll.pollId = newids;
        }

        this.pollService.updatePollQuestion(this.eventId, this.pollId, poll).then(res => {
            this.message = 'Update Successfully';
        }).catch(error => {
            this.errorMessage = error.message;
        });
        setTimeout(function () {
            this.message = null;
            this.disableButton = true;

            if (this.pollKey) {
                let newQuestionSet = [];
                let pollObject = { ...this.pollObject };
                delete pollObject.$key;
                if (pollObject.questions !== undefined) {
                    newQuestionSet = Object.values(pollObject.questions);
                }
                newQuestionSet.push(this.pollId);
                let questionSet = newQuestionSet.filter((v, i, a) => a.indexOf(v) === i);
                console.log(questionSet);
                this.pollService.updatePollDetail(this.eventId, this.pollKey, { ...pollObject, questions: questionSet });
                this.pollService.getPollDetail(this.eventId,prevPolls).subscribe((prevPollsDetails)=>{
                    if(prevPollsDetails != null && prevPollsDetails != undefined){
                        let PrevNewQuestionSet = [];
                        if (prevPollsDetails.questions !== undefined) {
                            PrevNewQuestionSet = Object.values(prevPollsDetails.questions);
                        }
                        PrevNewQuestionSet = PrevNewQuestionSet.filter((x)=>x != this.pollId )
                        let prevQuestionSet = PrevNewQuestionSet.filter((v, i, a) => a.indexOf(v) === i); 
                        this.pollService.updatePollDetail(this.eventId, prevPolls, { ...prevPollsDetails, questions: prevQuestionSet });
                    }
                    
                },(err) => console.error(err))
              
                
            }

            this.router.navigate([Constants.POLL_FORM, this.eventId]);
        }.bind(this), 3000);
    }

}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/event/poll-question/poll-question.component.ts